import {SanityImage} from '@local/ui/components'
import {SanityImageType} from '@local/types'

export interface BlockquoteProps {
	image: SanityImageType
	quote: string
	author: string
	company: string
}

export const Blockquote = ({image, quote, author, company}: BlockquoteProps) => {
	return (
		<div className='w-full lg:span-w-8 lg:flex my-60 py-20 border-t border-b border-black/10 text-24'>
			<div className='order-1 lg:order-2 lg:ml-20 lg-max:mb-20 lg-max:gap:10'>
				<p className="lg:mb-10 lg-max:after:mt-10 uppercase before:content-['“'] after:content-['”'] after:inline-block before:inline-block">
					{quote}
				</p>
				<p className='flex items-center text-10 before:block before:w-4 before:h-4 before:mr-6 before:bg-black'>
					{author} ({company})
				</p>
			</div>
			<SanityImage
				image={image}
				width={40}
				height={52}
				mobileWidth={40}
				desktopWidth={40}
				className='lg-max:order-2 lg:order:1 pointer-events-none select-none w-40 h-52 object-cover' />
		</div>
	)
}
